import React, { useState } from 'react';
import useCourses from '../Components/Hooks/useCourses';
import CourseCard from '../Components/CourseCard';
import LoadingSnipper from '../Components/Common/LoadingSnipper';

const Courses = () => {
    const { loading, courses } = useCourses();
    const [activeTab, setActiveTab] = useState(0);

    if (loading) {
        return <><LoadingSnipper /></>;
    }

    // Tab configuration
    const tabs = [
        { name: 'Básico', tense: 'PRESENTE', color: 'from-emerald-500 to-teal-600' },
        { name: 'Intermediário 1', tense: 'FUTURO', color: 'from-orange-500 to-red-500' },
        { name: 'Intermediário 2', tense: 'PASSADO', color: 'from-blue-600 to-slate-700' }
    ];

    return (
        <div className="w-full bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen py-12">
            {/* Header Section */}
            <div className="max-w-6xl mx-auto px-4 md:px-8 mb-12">
                <div className="text-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                        Meus Cursos de Inglês
                    </h1>
                    <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
                        Confira meus cursos super acessíveis e muito bem estruturados com exercícios de <span className="font-semibold">ÁUDIO</span>, <span className="font-semibold">SPEAKING</span>, <span className="font-semibold">FLASHCARDS</span>, <span className="font-semibold">TEXTOS</span> e muito mais!
                    </p>
                </div>
            </div>

            {/* Tabs Navigation */}
            <div className="max-w-6xl mx-auto px-4 md:px-8 mb-12">
                <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => setActiveTab(index)}
                            className={`flex-1 sm:flex-none px-6 md:px-8 py-3 md:py-4 rounded-xl font-semibold text-sm md:text-base transition-all duration-300 ${
                                activeTab === index
                                    ? `bg-gradient-to-r ${tab.color} text-white shadow-lg scale-105`
                                    : 'bg-white text-gray-700 border-2 border-gray-200 hover:border-gray-300'
                            }`}
                        >
                            <div className="flex flex-col md:flex-row items-center gap-2">
                                <span>{tab.name}</span>
                                <span className={`text-xs md:text-sm font-bold px-2 py-1 rounded-full ${
                                    activeTab === index
                                        ? 'bg-white/20'
                                        : 'bg-gray-100'
                                }`}>
                                    {tab.tense}
                                </span>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            {/* Course Content */}
            <div className="max-w-6xl mx-auto px-4 md:px-8">
                <div className="transition-all duration-300">
                    {courses[activeTab] && (
                        <CourseCard courses={courses[activeTab]} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Courses;
